import React from "react";
import classNames from "classnames/bind";
import { Clock } from "../../../../components";
import styles from "./StreamCam.module.css";
import { fontSize } from "./ConfigFontSize";

const cx = classNames.bind(styles);

/**
 * Camera footer component showing clock and temperature
 */
const CameraFooter = ({ item, screen, isFullScreen, hikEvent }) => {
    const temperature = hikEvent?.length > 0
        ? hikEvent?.find((e) => e?.camera_code === item?.code)?.temperature
        : item.temperature;

    const fontSizeValue = isFullScreen
        ? fontSize?.find((size) => size?.screen === screen?.total)?.sizeFs
        : fontSize?.find((size) => size?.screen === screen?.total)?.size;

    return (
        <div className={cx("footer")}>
            <div className={cx("time")} style={{ width: "100%" }}>
                <Clock
                    type_camera={item.type_camera}
                    temperature={temperature}
                    fontSize={fontSizeValue}
                />
            </div>
        </div>
    );
};

export default CameraFooter;

